import React, { useEffect } from 'react'

function AddRole({ sendDataToParent, onLoad }) {

  function handleChange(e) {
    const { name, type, checked, value } = e.currentTarget;
    sendDataToParent((prevState) => ({
      ...prevState,
      [name]: type === "checkbox" ? checked : value,
    }));
  }

  useEffect(() => {
    onLoad(undefined);
  }, []);

  return (
    <>
      <div className="row">
        <div className="mb-3">
          <label className="form-label">
            Role Name<span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="RoleName"
            onChange={handleChange}
          />
        </div>

        <div className="col-lg-12">
          <div className="summer-description-box transfer mb-3">
            <label className="form-label">Normalized Name</label>
            <input
              type="text"
              className="form-control"
              name="NormalizedName"
              onChange={handleChange}
            />
          </div>
        </div>

        {/* Admin Rights Checkbox */}
        <div className="col-lg-12">
          <div className="form-check mb-3">
            <input
              type="checkbox"
              className="form-check-input"
              id="HasAdminRights"
              name="HasAdminRights"
              onChange={handleChange}
            />
            <label className="form-check-label" htmlFor="HasAdminRights">
              Has Admin Rights
            </label>
          </div>
        </div>
      </div>
    </>
  )
}

export default AddRole